//quiz
window.addEventListener("load", (event) => {
  window.FindationB = window.Findation || {},
  initWidgetB = function() {
    FindationB.init(document.getElementById("findation-widget-button-b"), "c34cfad313000bf88138ce292dc892813a0a4d378e0089db0082f1c101d6")
  },
  FindationB.widgetDidOpen = function() {
    dataLayer.push({'event': 'findation_widget_opened'});
  },
  FindationB.onSearchComplete = function (data) {
    dataLayer.push({
      'event': 'findation_widget_search_complete',
      'findation_widget_search_complete': {
        'countShadesEntered': data.countShadesEntered,
        'matchSuccess': data.matchSuccess,
        'recommendedShade': data.recommendedShade,
        'shadesEntered': data.shadesEntered,
        'externalId': data.externalId
      }
    });
    
    if (data.matchSuccess) {
      dataLayer.push({'event': 'findation_widget_recommendation'});
    } else {
      dataLayer.push({'event': 'findation_widget_no_recommendation'});
    }
    
    document.getElementById("findation_result") && (data.matchSuccess ? document.getElementById("findation_result").innerText = data.recommendedShade : document.getElementById("findation_result").innerText = "no recommendation")
  }  

  initWidgetB();
});

// last step is required for all time break
var last_step = [...document.querySelectorAll('.quiz-step')].length - 1;
var current_jumpstep = default_jumpstep = ([...document.querySelectorAll('.quiz-step')].length - 1);
var stepClickEvent = (evt) => {
  evt.preventDefault();

  //if resubmit email wrapper exist, remove it
  let resubmitEmail = document.querySelector('.email-wrapper');
  if (resubmitEmail) {
    resubmitEmail.remove();
  }

  let target = evt.target.getAttribute('href') ? evt.target : evt.target.closest('a');
  let questionContainer = target.parentElement.parentElement;
  if (!questionContainer.classList.contains('section-blocks')) {
    questionContainer = questionContainer.parentElement;
  }

  let step = target.getAttribute('href').replace('#', '');
  step = parseInt(step.replace('quiz-step', ''), 10);

  if (questionContainer.querySelector('input:checked')) {
    let isTimebreakStep = questionContainer.getAttribute('data-timebreak');
    if (isTimebreakStep === 'true') {
      current_jumpstep = parseInt(questionContainer.querySelector('input:checked').getAttribute('data-jumpstep'), 10);
    }
  }

  if (target.classList.contains('btn--primary')) {
    //forward
    //check if we got the required answer
    if (questionContainer.querySelectorAll('input[required]').length) {
      let element = questionContainer.querySelector('input[required]');
      let isValid = validate(element, questionContainer);
  
      if (!isValid) return;
    }

    if (current_jumpstep !== default_jumpstep && ([...document.querySelectorAll('.quiz-step')].indexOf(target.closest('section')) + 1) === current_jumpstep) {
      [...document.querySelectorAll('.quiz-step')].slice(last_step, last_step + 1).pop().style.display = "block";
    } else {
      [...document.querySelectorAll('.quiz-step')].slice(step - 1, step).pop().style.display = "block";
    }

    if (step > 1) {
      document.querySelector('.main .shopify-section:first-of-type').style.setProperty('--progress-width', (step / (current_jumpstep + 1)) * 100 + '%');

      [...document.querySelectorAll('.quiz-step')].slice(step - 2, step - 1).pop().style.display = "none";
    }

  } else {
    //backward
    if (current_jumpstep !== default_jumpstep && [...document.querySelectorAll('.quiz-step')].indexOf(target.closest('section')) == last_step) {
      [...document.querySelectorAll('.quiz-step')].slice(current_jumpstep - 1, current_jumpstep).pop().style.display = "block";
      [...document.querySelectorAll('.quiz-step')].slice(last_step, last_step + 1).pop().style.display = "none";
    } else {
      [...document.querySelectorAll('.quiz-step')].slice(step - 1, step).pop().style.display = "block";
      [...document.querySelectorAll('.quiz-step')].slice(step, step + 1).pop().style.display = "none";
    }


    if (step === 1) {
      document.querySelector('.main .shopify-section:first-of-type').style.display = "none";
    } else if (step === last_step) {
      document.querySelector('.main .shopify-section:first-of-type').style.setProperty('--progress-width', (current_jumpstep / (current_jumpstep + 1)) * 100 + '%');
    } else {
      document.querySelector('.main .shopify-section:first-of-type').style.setProperty('--progress-width', (step / (current_jumpstep + 1)) * 100 + '%');
    }

      
  }

  if (step >= 2) {
    document.querySelector('.main .shopify-section:first-of-type').style.display = "block";
  }

  // hide intro screen
  [...document.querySelectorAll('.main .shopify-section')].slice(1, 2).forEach((intro) => {
    intro.style.display = 'none';
  });

  gtag("event", "click", {
    "event_category": "quiz",
    "event_label": target.innerText
  });
};

var hasError = (field) => {
  // Don't validate submits, buttons, file and reset inputs, and disabled fields
  if (field.type === 'submit' || field.type === 'button') return;

  // Get validity
  let validity = field.validity;

  // If valid, return null
  if (validity.valid) return;

  // If field is required and empty
  if (validity.valueMissing) return true;

  // If not the right type
  if (validity.typeMismatch) {
    // Email
    if (field.type === 'email') return true;
  }
  return false;

};

var validate = (element, container) => {
  // Validate the field
  var error = hasError(element);

  // If there's an error, show it
  if (error && container.querySelector('.error-message') == null) {
    let error_p = document.createElement("p");
    error_p.append("This question is required.");
    error_p.classList.add('error-message');
    if (container.querySelector('.rich-text__heading')) {
      container.querySelector('.rich-text__heading').after(error_p);
    } else {
      container.prepend(error_p);
    }

    container.querySelectorAll('input[required]').forEach((e) => {
      e.classList.add('error');
    });
    return false;
  } else if (error && container.querySelector('.error-message')) { 
    // error exist on page
    return false;
  } else if (container.querySelector('.error-message')) {
    // Otherwise, remove any existing error message
    container.querySelectorAll('input[required]').forEach((e) => {
      e.classList.remove('error');
    });
    container.querySelector('.error-message').remove();
    return true;
  }

  return true;
}

var setCookie = (cname, cvalue, exdays) => {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/;";
};

var getCookie = (cname) => {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

var getParam = (key) => {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == key) {
      return pair[1];
    }
  }
};

const concealer_bb = {
  '001C':'Fair 1C',
  '002C':'Fair 2N',
  '003N':'Fair 2N',
  '004N':'Fair 3N',
  '005C':'Light 1C',
  '006W':'Light 2W',
  '007N':'Light 3N',
  '008W':'Light 2W',
  '009C':'Light 4C',
  '010W':'Medium 2N',
  '012C':'Medium 1N',
  '013W':'Medium 3C',
  '014N':'Medium 3C',
  '015C':'Medium 3C',
  '016W':'Deep 1N',
  '017W':'Medium 4W',
  '019N':'Deep 2N',
  '020C':'Deep 3C',
  '021N':'Deepest 2N'
};

var createStak = (hasRec, findationRec) => {
  let skinTone, eyeColor, makeup, skinCondition, browColor, displayMsg; 
  document.querySelectorAll('input[required]:checked').forEach((input) => {
    let heading = input.parentElement.parentElement.querySelector('.rich-text__heading').textContent;

    if (heading.indexOf('skin tone') !== -1) {
      skinTone = input.value;
      if (!hasRec) displayMsg = input.getAttribute('data-msg');
    } else if (heading.indexOf('eye color') !== -1) {
      eyeColor = input.value.toLowerCase();
    } else if(heading.indexOf('makeup') !== -1) {
      makeup = input.value.toLowerCase();
    } else if(heading.indexOf('describe your skin') !== -1) {
      skinCondition = input.value.toLowerCase();
    } else if(heading.indexOf('brow hair color') !== -1) {
      browColor = input.value.toLowerCase();
    }
  });

  let stak = {
    'findation_recommendation': findationRec,
    'concealer': findationRec,
    'shine_control': skinCondition.indexOf('dry') === 0 ? '' : 'Translucent',
    'display_message': displayMsg
  };

  switch (skinTone) {
    case 'deep':
      if (stak.findation_recommendation === 'no recommendation') {
        stak.concealer = '019N';
        stak.bb_powder = 'Deep 2N';
      } else {
        stak.bb_powder = concealer_bb[stak.concealer];
      }

      //lip-cheek
      if (makeup.indexOf('minimalist') !== -1) {
        stak.lipcheek = 'Auburn Adventure';
      } else if (makeup.indexOf('occasionally') !== -1) {
        stak.lipcheek = 'Auburn Adventure';
      } else if (makeup.indexOf('complexion') !== -1) {
        stak.lipcheek = 'Bordeaux on the Go';
      } else {
        stak.lipcheek = 'Bordeaux on the Go';
      }

      // lip glaze
      if (makeup.indexOf('minimalist') !== -1) {
        stak.lip_glaze = 'Undone';
      } else if (makeup.indexOf('occasionally') !== -1) {
        stak.lip_glaze = 'Undone';
      } else if (makeup.indexOf('complexion') !== -1) {
        stak.lip_glaze = 'Wild';
      } else {
        stak.lip_glaze = 'Wild';
      }

      //blush
      if (makeup.indexOf('minimalist') !== -1) {
        stak.blush = 'Daytrip at Dawn';
      } else if (makeup.indexOf('occasionally') !== -1) {
        stak.blush = 'Pink in a Pinch';
      } else if (makeup.indexOf('complexion') !== -1) {
        stak.blush = 'Pink in a Pinch';
      } else {
        stak.blush = 'Pink in a Pinch';
      }

      //bronzer
      if(skinCondition.toLowerCase() === 'oily') {
        stak.bronzer = "Espresso";
      } else {
        stak.bronzing_balm = "Ganache";
      }

      //eyeshadow
      switch (eyeColor) {
        case 'brown':
          stak.eyeshadow = 'Dune';
          break;
        case 'hazel':
          stak.eyeshadow = 'Dune';
          break;
        case 'blue':
          stak.eyeshadow = 'Dune';
          break;
        case 'green':
          stak.eyeshadow = 'Dune';
          break;
        case 'amber':
        default:
          stak.eyeshadow = 'Dune';
          break;
      }

      //highlighter
      stak.highlighter = 'Espresso Martini Cream';

      break;
    case 'dark':
      if (stak.findation_recommendation === 'no recommendation') {
        stak.concealer = '015C';
        stak.bb_powder = 'Medium 3C';
      } else {
        stak.bb_powder = concealer_bb[stak.concealer];
      }

      //lip-cheek
      if (makeup.indexOf('minimalist') !== -1) {
        stak.lipcheek = 'Auburn Adventure';
      } else if (makeup.indexOf('occasionally') !== -1) {
        stak.lipcheek = 'Auburn Adventure';
      } else if (makeup.indexOf('complexion') !== -1) {
        stak.lipcheek = 'Bordeaux on the Go';
      } else {
        stak.lipcheek = 'Bordeaux on the Go';
      }

      // lip glaze
      if (makeup.indexOf('minimalist') !== -1) {
        stak.lip_glaze = 'Undone';
      } else if (makeup.indexOf('occasionally') !== -1) {
        stak.lip_glaze = 'Undone';
      } else if (makeup.indexOf('complexion') !== -1) {
        stak.lip_glaze = 'Wild';
      } else {
        stak.lip_glaze = 'Wild';
      }

      //blush
      if (makeup.indexOf('minimalist') !== -1) {
        stak.blush = 'Daytrip at Dawn';
      } else if (makeup.indexOf('occasionally') !== -1) {
        stak.blush = 'Blossom Bound';
      } else if (makeup.indexOf('complexion') !== -1) {
        stak.blush = 'Pink in a Pinch';
      } else {
        stak.blush = 'Pink in a Pinch';
      }

      //bronzer
      if(skinCondition.toLowerCase() === 'oily') {
        stak.bronzer = "Cocoa";
      } else {
        stak.bronzing_balm = "Truffle";
      }

      //eyeshadow
      switch (eyeColor) {
        case 'brown':
          stak.eyeshadow = 'Dune';
          break;
        case 'hazel':
          stak.eyeshadow = 'Dune';
          break;
        case 'blue':
          stak.eyeshadow = 'Dune';
          break;
        case 'green':
          stak.eyeshadow = 'Dune';
          break;
        case 'amber':
        default:
          stak.eyeshadow = 'Dune';
          break;
      }

      //highlighter
      stak.highlighter = 'Espresso Martini Cream';

      break;
    case 'tan':
      if (stak.findation_recommendation === 'no recommendation') {
        stak.concealer = '012C';
        stak.bb_powder = 'Medium 1N';
      } else {
        stak.bb_powder = concealer_bb[stak.concealer];
      }

      //lip-cheek
      if (makeup.indexOf('minimalist') !== -1) {
        stak.lipcheek = 'Terracotta Tour Guide';
      } else if (makeup.indexOf('occasionally') !== -1) {
        stak.lipcheek = 'Raspberry Room Service';
      } else if (makeup.indexOf('complexion') !== -1) {
        stak.lipcheek = 'Bordeaux on the Go';
      } else {
        stak.lipcheek = 'Passport to Plum';
      }

      // lip glaze
      if (makeup.indexOf('minimalist') !== -1) {
        stak.lip_glaze = 'Undone';
      } else if (makeup.indexOf('occasionally') !== -1) {
        stak.lip_glaze = 'Magnetic';
      } else if (makeup.indexOf('complexion') !== -1) {
        stak.lip_glaze = 'Unapologetic';
      } else {
        stak.lip_glaze = 'Wild';
      }

      //blush
      if (makeup.indexOf('minimalist') !== -1) {
        stak.blush = 'Daytrip at Dawn';
      } else if (makeup.indexOf('occasionally') !== -1) {
        stak.blush = 'Daytrip at Dawn';
      } else if (makeup.indexOf('complexion') !== -1) {
        stak.blush = 'Pink in a Pinch';
      } else {
        stak.blush = 'Blossom Bound';
      }

      //bronzer
      if(skinCondition.toLowerCase() === 'oily') {
        stak.bronzer = "Mocha";
      } else {
        stak.bronzing_balm = "Toffee";
      } 

      //eyeshadow
      switch (eyeColor) {
        case 'hazel':
        case 'blue':
          stak.eyeshadow = 'Dune';
          break;
        case 'brown':
          stak.eyeshadow = 'Dune';
          break;
        case 'green':
          stak.eyeshadow = 'Dune';
          break;
        case 'amber':
        default:
          stak.eyeshadow = 'Dune';
          break;
      }

      //highlighter
      if (skinCondition.indexOf('oily') !== -1 || skinCondition.indexOf('combination') !== -1 || skinCondition.indexOf('normal') !== -1) {
        stak.highlighter = 'Champagne Powder';
      } else {
        stak.highlighter = 'Rosé Cream';
      }

      break;    
    case 'medium':
      if (stak.findation_recommendation === 'no recommendation') {
        stak.concealer = '008W';
        stak.bb_powder = 'Light 2W';
      } else {
        stak.bb_powder = concealer_bb[stak.concealer];
      }

      //lip-cheek
      if (makeup.indexOf('minimalist') !== -1) {
        stak.lipcheek = 'Terracotta Tour Guide';
      } else if (makeup.indexOf('occasionally') !== -1) {
        stak.lipcheek = 'Guava Getaway';
      } else if (makeup.indexOf('complexion') !== -1) {
        stak.lipcheek = 'Raspberry Room Service';
      } else {
        stak.lipcheek = 'Bordeaux on the Go';
      }

      // lip glaze
      if (makeup.indexOf('minimalist') !== -1) {
        stak.lip_glaze = 'Undone';
      } else if (makeup.indexOf('occasionally') !== -1) {
        stak.lip_glaze = 'Magnetic';
      } else if (makeup.indexOf('complexion') !== -1) {
        stak.lip_glaze = 'Unapologetic';
      } else {
        stak.lip_glaze = 'Wild';
      }

      //blush
      if (makeup.indexOf('minimalist') !== -1) {
        stak.blush = 'Daytrip at Dawn';
      } else if (makeup.indexOf('occasionally') !== -1) {
        stak.blush = 'Daytrip at Dawn';
      } else if (makeup.indexOf('complexion') !== -1) {
        stak.blush = 'Pink in a Pinch';
      } else {
        stak.blush = 'Blossom Bound';
      }

      //bronzer
      if(skinCondition.toLowerCase() === 'oily') {
        stak.bronzer = "Mocha";
      } else {
        stak.bronzing_balm = "Toffee";
      } 

      //eyeshadow
      switch (eyeColor) {
        case 'brown':
          stak.eyeshadow = 'Dune';
          break;
        case 'blue':
          stak.eyeshadow = 'Crush';
          break;
        case 'hazel':
          stak.eyeshadow = 'Crush';
          break;
        case 'green':
          stak.eyeshadow = 'Dune';
          break;
        case 'amber':
        default:
          stak.eyeshadow = 'Dune';
          break;
      }

      //highlighter
      if (skinCondition.indexOf('oily') !== -1 || skinCondition.indexOf('combination') !== -1 || skinCondition.indexOf('normal') !== -1) {
        stak.highlighter = 'Champagne Powder';
      } else {
        stak.highlighter = 'Champagne Cream';
      }

      break;
    case 'light':
      if (stak.findation_recommendation === 'no recommendation') {
        stak.concealer = '003N';
        stak.bb_powder = 'Fair 2N';
      } else {
        stak.bb_powder = concealer_bb[stak.concealer];
      }

      //lip-cheek        
      if (makeup.indexOf('minimalist') !== -1) {
        stak.lipcheek = 'Runway to Rose';
      } else if (makeup.indexOf('occasionally') !== -1) {
        stak.lipcheek = 'Guava Getaway';
      } else if (makeup.indexOf('complexion') !== -1) {
        stak.lipcheek = 'Raspberry Room Service';
      } else {
        stak.lipcheek = 'Bordeaux on the Go';
      }

      // lip glaze
      if (makeup.indexOf('minimalist') !== -1) {
        stak.lip_glaze = 'Iconic';
      } else if (makeup.indexOf('occasionally') !== -1) {
        stak.lip_glaze = 'Magnetic';
      } else if (makeup.indexOf('complexion') !== -1) {
        stak.lip_glaze = 'Wild';
      } else {
        stak.lip_glaze = 'Unapologetic';
      }

      //blush
      if (makeup.indexOf('minimalist') !== -1) {
        stak.blush = 'Daytrip at Dawn';
      } else if (makeup.indexOf('occasionally') !== -1) {
        stak.blush = 'Daytrip at Dawn';
      } else if (makeup.indexOf('complexion') !== -1) {
        stak.blush = 'Pink in a Pinch';
      } else {
        stak.blush = 'Blossom Bound';
      }

      //bronzer
      if(skinCondition.toLowerCase() === 'oily') {
        stak.bronzer = "Latte";
      } else {
        stak.bronzing_balm = "Caramel";
      } 

      //eyeshadow
      switch (eyeColor) {
        case 'hazel':
          stak.eyeshadow = 'Staycation';
          break;
        case 'blue':
          stak.eyeshadow = 'Jelly';
          break;
        case 'green':
          stak.eyeshadow = 'Staycation';
          break;
        case 'brown':
          stak.eyeshadow = 'Staycation';
          break;
        case 'amber':
        default:
          stak.eyeshadow = 'Dune';
          break;
      }
      
      //highlighter
      if (skinCondition === "oily") {
        stak.highlighter = 'Champagne Powder';
      } else {
        stak.highlighter = 'Champagne Cream';
      }

      break;
    case 'fair':
    default:
      if (stak.findation_recommendation === 'no recommendation') {
        stak.concealer = '001C';
        stak.bb_powder = 'Fair 1C';
      } else {
        stak.bb_powder = concealer_bb[stak.concealer];
      }

      //lip-cheek
      if (makeup.indexOf('minimalist') !== -1) {
        stak.lipcheek = 'Mauve in the Maldives';
      } else if (makeup.indexOf('occasionally') !== -1) {
        stak.lipcheek = 'Guava Getaway';
      } else if (makeup.indexOf('complexion') !== -1) {
        stak.lipcheek = 'Raspberry Room Service';
      } else {
        stak.lipcheek = 'Bordeaux on the Go';
      }

      // lip glaze
      stak.lip_glaze = "Iconic";
      if (makeup.indexOf('minimalist') !== -1) {
        stak.lip_glaze = 'Undone';
      } else if (makeup.indexOf('occasionally') !== -1) {
        stak.lip_glaze = 'Iconic';
      } else if (makeup.indexOf('complexion') !== -1) {
        stak.lip_glaze = 'Magnetic';
      } else {
        stak.lip_glaze = 'Wild';
      }

      //blush
      if (makeup.indexOf('minimalist') !== -1) {
        stak.blush = 'Daytrip at Dawn';
      } else if (makeup.indexOf('occasionally') !== -1) {
        stak.blush = 'Daytrip at Dawn';
      } else if (makeup.indexOf('complexion') !== -1) {
        stak.blush = 'Pink in a Pinch';
      } else {
        stak.blush = 'Blossom Bound';
      }

      //bronzer
      if(skinCondition.toLowerCase() === 'oily') {
        stak.bronzer = "Leche";
      } else {
        stak.bronzing_balm = "Biscotti";
      } 

      //eyeshadow
      switch (eyeColor) {
        case 'brown':
          stak.eyeshadow = 'Staycation';
          break;
        case 'green':
          stak.eyeshadow = 'Cloud Nine';
          break;
        case 'hazel':
          stak.eyeshadow = 'Staycation';
          break;
        case 'blue':
          stak.eyeshadow = 'Jelly';
          break;
        case 'amber':
        default:
          stak.eyeshadow = 'Staycation';
          break;
      }

      //highlighter
      stak.highlighter = 'Champagne Cream';

      break;
  }

  //brow
  switch (browColor) {
    case 'blonde':
      stak.browColor = 'Taupe';
      break;
    case 'auburn':
      stak.browColor = 'Auburn';
      break;
    case 'medium brown':
      stak.browColor = 'Medium Brown';
      break;
    case 'dark brown':
      stak.browColor = 'Dark Brown';
      break;
    case 'black':
    default:
      stak.browColor = 'Black';
      break;
  }  

  return stak;
}

var retrieveStak = (stak) => {
  let decodedStak = atob(stak);
  try {
    return JSON.parse(decodedStak);
  } catch (e) {}
}

var updateNav = () => {
  // change mobile empty cart to view my results
  let mobileCartBtn = document.querySelector('.quick-cart__empty-state .sticky-button');
  if(mobileCartBtn) {
    mobileCartBtn.setAttribute('href', '/pages/quiz#see-my-results');
    mobileCartBtn.querySelector('span').textContent = 'view my results';
  }
}

var mapToProducts = (stak) => {

  //reset all products
  document.querySelectorAll('input[type="radio"][name="option-0"]').forEach((input) => {
    if (input.parentElement.classList.contains('rec')) {
      input.parentElement.classList.remove('rec');
    }
    
    if (input.parentElement.classList.contains('show-all')) {
      input.parentElement.classList.remove('show-all');
    }

    let swatchWrapper = input.parentElement.parentElement.parentElement;
    let optionLink = swatchWrapper.querySelector('.option-link');

    if (!optionLink) {
      let list = [...swatchWrapper.getElementsByTagName('li')];
      if (list.length > 1) {
        optionLink = document.createElement("a");
        swatchWrapper.appendChild(optionLink);

        optionLink.addEventListener('click', (evt) => {
          evt.preventDefault();
          let link = evt.target.getAttribute('href') ? evt.target : evt.target.parentElement;

          if (link.textContent === "See More Options") {
            list.forEach(li => {
              if (!li.classList.contains('product-swatches-options__item-overflow-note')) { li.classList.add('show-all') };
            });

            link.setAttribute('href', '#show-recommendation');
            link.querySelector('span').textContent = 'See Recommendation';
          } else {
            list.forEach(li => {
              li.classList.remove('show-all');
              if (li.classList.contains('rec')) {
                li.querySelector('label').click();
              }
            });

            link.setAttribute('href', '#see-more-options');
            link.querySelector('span').textContent = 'See More Options';
          }
        });
      } else {
        swatchWrapper.style.paddingBottom = '21px';
      }
    }

    if (optionLink) {
      optionLink.classList.add('option-link', 'btn', 'btn--callout');
      optionLink.setAttribute('href', '#see-more-options');
      optionLink.innerHTML = '<span>See More Options</span>';
    }
  });

  // map shine control
  if (stak.shine_control === '') {
    //hide shine control
    let product_title = [...document.querySelectorAll('.product-item__product-title')].filter(pt => {
      return pt.textContent.toLowerCase().indexOf('shine control') !== -1;
    }).pop();

    product_title.closest('.featured-collection-grid__product').style.display = 'none';
  }

  // map highlighter
  if (stak.highlighter.indexOf('Powder') !== -1) {
    //hide cream highlighter
    let product_title = [...document.querySelectorAll('.product-item__product-title')].filter(pt => {
      return pt.textContent.toLowerCase().indexOf('cream highlighter') !== -1;
    }).pop();

    product_title.closest('.featured-collection-grid__product').style.display = 'none';
  } else {
    //hide powder highlighter
    let product_title = [...document.querySelectorAll('.product-item__product-title')].filter(pt => {
      return pt.textContent.toLowerCase().indexOf('powder highlighter') !== -1;
    }).pop();

    product_title.closest('.featured-collection-grid__product').style.display = 'none';
  }

  //map bronzer and bronzing balm
  if(typeof stak.bronzer !== 'undefined') {
    //hide bronzing balm
    let product_title = [...document.querySelectorAll('.product-item__product-title')].filter(pt => {
      return pt.textContent.toLowerCase().indexOf('bronzing balm') !== -1;
    }).pop();

    product_title.closest('.featured-collection-grid__product').style.display = 'none';
  } else {
    //hide bronzer
    let product_title = [...document.querySelectorAll('.product-item__product-title')].filter(pt => {
      return pt.textContent.toLowerCase().indexOf('bronzer') !== -1;
    }).pop();

    product_title.closest('.featured-collection-grid__product').style.display = 'none';
  }

  let visibleProducts = [...document.querySelectorAll('.featured-collection-grid__product')].filter(p =>
    window.getComputedStyle(p).getPropertyValue('display') != 'none'
  );
  

  visibleProducts.forEach(p => {
    let title = p.querySelector('.product-item__product-title').textContent.toLowerCase(), rec;

    if (title.indexOf('concealer') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="' + stak.concealer + '"]');
    } else if (title.indexOf('bb powder') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="' + stak.bb_powder + '"]');
    } else if (title.indexOf('lip and cheek') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="' + stak.lipcheek + '"]');
    } else if (title.indexOf('eyeshadow') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="' + stak.eyeshadow + '"]');
    } else if (title.indexOf('blush') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="' + stak.blush + '"]');
    } else if (title.indexOf('bronzer') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="' + stak.bronzer + '"]');
    } else if (title.indexOf('bronzing balm') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="' + stak.bronzing_balm + '"]');
    } else if (title.indexOf('highlighter') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="' + stak.highlighter.replace('Cream', '').replace('Powder', '').trim() + '"]');
    }  else if (title.indexOf('shine control') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="' + stak.shine_control + '"]');
    } else if (title.indexOf('brow') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="' + stak.browColor + '"]');        
    } else if (title.indexOf('lip balm') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="Original Unflavored"]');
    } else if (title.indexOf('lip glaze') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="' + stak.lip_glaze + '"]');
    }

    rec.parentElement.classList.add('rec');
    rec.click();
  });
}

var goToResults = () => {
  let post = (window.location.search.indexOf('post') !== -1) ? decodeURIComponent(getParam('post').replace(/%20/g, '+')) : getCookie('post');
  let stak = retrieveStak(post);

  if(typeof stak.bb_powder === 'undefined') {
    stak.bb_powder = concealer_bb[stak.concealer];
  }

  mapToProducts(stak);

  // add chat event
  let resultDetail = document.querySelector('.featured-collection-grid__inner .featured-collection-grid__content .featured-collection-grid__subheading');
  if(resultDetail === null || document.querySelectorAll('.featured-collection-grid__inner .featured-collection-grid__content .featured-collection-grid__subheading').length === 1){
    resultDetail = document.querySelector('.quiz-result-detail .rich-text__heading + .rich-text__text');
  } else {
    if(document.querySelectorAll('.featured-collection-grid__inner .featured-collection-grid__content .featured-collection-grid__subheading').length > 1) {
      document.querySelector('.quiz-result-detail .rich-text__heading + .rich-text__text').innerHTML = "";
    }
  }

  if (stak.findation_recommendation === 'no recommendation') {
    resultDetail.innerHTML = stak.display_message;
  } else {
    resultDetail.innerHTML = "";
  }

  if(document.querySelectorAll('.featured-collection-grid__inner .featured-collection-grid__content .featured-collection-grid__subheading').length === 1) {
    let ctas = [...document.querySelectorAll('.quiz-result-detail .rich-text__inner > *')].filter((el) => {
      return el.tagName === 'BUTTON' || el.tagName === 'A';
    });
    let hasScrollArrow = !!document.querySelector('.quiz-result-detail .scroll-down-arrow');

    if(ctas.length <= 0 && !hasScrollArrow) {
      const scrollArrow = document.createElement("div");
      scrollArrow.classList.add('scroll-down-arrow'); 

      document.querySelector('.quiz-result-detail .rich-text__inner').append(scrollArrow);
    }
  }
  document.querySelectorAll('.main .shopify-section:first-of-type, .quiz-step').forEach((step) => {
    step.style.display = 'none';
  });
  
  // hide intro screen
  [...document.querySelectorAll('.main .shopify-section')].slice(1, 2).forEach((intro) => {
    intro.style.display = 'none';
  });

  // show results
  document.querySelectorAll('.quiz-result').forEach((result) => {
    result.style.display = 'block';
  });
  [...document.querySelectorAll('.shopify-section')].slice(-5, -1).forEach((result) => {
    result.style.display = 'block';
  });
}

var initiateFirstStep = () => {
  const isNewQuizV2 = document.body.classList.contains("new-quiz-v2");
 
  document.querySelector('.image-hero__image-container').style.maxHeight = '80vh';
  document.querySelector('.image-hero__text-container-wrapper').classList.add('mobile-lower-position');

  // document.querySelectorAll('.image-hero__text-container-text')[1].style.display = 'none';
  const elements = document.querySelectorAll('.image-hero__text-container-text');
  if (elements.length > 1) {
    elements[1].style.display = 'none';
  }


  let timeA = document.querySelector('.image-hero__text-container-wrapper .button-block__button');
  let timeB = timeA.cloneNode();
  let linkA = timeA.childNodes[0];

  linkA.setAttribute('href', '#quiz-step2');
  linkA.setAttribute('data-jumpstep', 14);
  if (isNewQuizV2){
    linkA.setAttribute('data-jumpstep', 7);
  }

  if (!isNewQuizV2) {
    linkA.classList.remove('btn--primary');
    linkA.classList.add('btn--secondary');
    linkA.childNodes[1].innerHTML = '<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.50065 3.33329H4.33398C4.05784 3.33329 3.83398 3.10943 3.83398 2.83329V2.16663C3.83398 1.89048 4.05784 1.66663 4.33398 1.66663H16.6673C16.9435 1.66663 17.1673 1.89048 17.1673 2.16663V2.83329C17.1673 3.10944 16.9435 3.33329 16.6673 3.33329H15.5007V4.99996C15.5007 6.34579 14.8207 7.42913 13.964 8.31413C13.3782 8.91913 12.6657 9.47663 11.9432 9.99996C12.6657 10.5233 13.3782 11.0808 13.964 11.6858C14.8207 12.5708 15.5007 13.6541 15.5007 15V16.6666H16.6673C16.9435 16.6666 17.1673 16.8905 17.1673 17.1666V17.8333C17.1673 18.1094 16.9435 18.3333 16.6673 18.3333H4.33398C4.05784 18.3333 3.83398 18.1094 3.83398 17.8333V17.1666C3.83398 16.8905 4.05784 16.6666 4.33398 16.6666H5.50065V15C5.50065 13.6541 6.18065 12.5708 7.03732 11.6858C7.62315 11.0808 8.33565 10.5233 9.05815 9.99996C8.33565 9.47663 7.62315 8.91913 7.03732 8.31413C6.18065 7.42913 5.50065 6.34579 5.50065 4.99996V3.33329ZM7.16732 3.33329V4.99996C7.16732 5.57079 7.38398 6.11246 7.80982 6.66663H13.1915C13.6165 6.11246 13.834 5.57079 13.834 4.99996V3.33329H7.16732ZM10.5007 11.0183C9.62982 11.6333 8.84065 12.2191 8.23482 12.845C8.08422 12.9997 7.94234 13.1628 7.80982 13.3333H13.1915C13.059 13.1628 12.9171 12.9997 12.7665 12.845C12.1607 12.2191 11.3715 11.6333 10.5007 11.0183Z" fill="#57201f"/></svg>no rush, find my ideal stak (5 minutes)';
    linkA.childNodes[1].classList = 'watch-glass';
  
    Object.assign(linkA.parentElement.style, {
      'max-width': '100%',
      'min-width': '310px',
      'justify-content': 'center'
    });
  }


  let linkB = document.createElement('a');
  linkB.setAttribute('href', '#quiz-step2');
  linkB.setAttribute('data-jumpstep', 7);
  if (!isNewQuizV2) {
    linkB.classList.add('btn', 'btn--overlay', 'btn--full', 'btn--secondary');
    linkB.setAttribute('aria-hidden', false);
    linkB.innerHTML = '<span class="lighting"><svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.81051 7.85006C4.85762 7.75557 5 7.7891 5 7.89468V8.5C5 8.77614 5.22386 9 5.5 9H7.95201C8.32345 9 8.56521 9.39068 8.39947 9.7231L7.18949 12.1499C7.14238 12.2444 7 12.2109 7 12.1053V11.5C7 11.2239 6.77614 11 6.5 11H4.04799C3.67655 11 3.43479 10.6093 3.60053 10.2769L4.81051 7.85006ZM7 1.11803C7 0.590422 6.28874 0.422516 6.05279 0.894427L0.361804 12.2764C0.195578 12.6088 0.437326 13 0.809017 13H4.5C4.77614 13 5 13.2239 5 13.5V18.882C5 19.4096 5.71126 19.5775 5.94721 19.1056L11.6382 7.72361C11.8044 7.39116 11.5627 7 11.191 7H7.5C7.22386 7 7 6.77614 7 6.5V1.11803Z" fill="#57201f"/></svg>i barely have time (30 seconds)</span>';
  
    timeB.append(linkB);
    timeA.after(timeB);
  
    Object.assign(linkB.parentElement.style, {
      'max-width': '100%',
      'min-width': '310px',
      'justify-content': 'center'
    });
  }

  linkA.removeEventListener('click', stepClickEvent);

  [linkA, linkB].forEach((link) => {
    link.addEventListener('click', (evt) => {
      evt.preventDefault();
      let target = evt.target;
      if (target.getAttribute('data-jumpstep') === null) {
        target = target.parentElement;
      }
      current_jumpstep = parseInt(target.getAttribute('data-jumpstep'), 10);

      document.querySelector('input[type=radio][data-jumpstep="' + current_jumpstep + '"]').click();
      document.querySelector('.main .shopify-section:first-of-type').style.setProperty('--progress-width', (2 / (current_jumpstep + 1)) * 100 + '%');
      [...document.querySelectorAll('.quiz-step')].slice(1, 2).pop().style.display = "block";
      [...document.querySelectorAll('.quiz-step')].slice(0, 1).pop().style.display = "none";
      stepClickEvent(evt);
    });
  });

  let resultLink = document.querySelector('a[href="#see-my-results"]');
  resultLink.classList.remove('btn--overlay', 'btn--full', 'btn--secondary');
  resultLink.classList.add('btn--callout');

  Object.assign(resultLink.parentElement.style, {
    'max-width': '100%',
    'width': '100%',
    'justify-content': 'center'
  });
  

  if (getCookie('post')) {
    updateNav();
  } else {
    resultLink.setAttribute('href', '#request-my-result');
    resultLink.innerHTML = '<span>already completed the quiz? get your results</span>';

    resultLink.addEventListener('click', (evt) => {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      evt.stopPropagation();

      if(document.querySelector('.email-wrapper') === null) {
        let emailWrapper = document.createElement('div');
        emailWrapper.classList.add('email-wrapper');
        emailWrapper.innerHTML = '<label for="email_resubmit" class="visually-hidden">Email*</label>'
          + '<input autocomplete="email" type="email" id="email_resubmit" name="email" placeholder="email*" class="input" spellcheck="false" autocapitalize="off" value="" required aria-required="true">'
          + '<a href="#quiz-resubmit" class="btn btn--overlay btn--small btn--primary"><span>send</span></a>';
        
        resultLink.parentElement.parentElement.after(emailWrapper);
    
        document.querySelector('a[href="#quiz-resubmit"]').addEventListener('click', (evt) => {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          evt.stopPropagation();
    
          let email = document.getElementById('email_resubmit');
          let isValid = validate(email, document.querySelector('.email-wrapper'));
          
          if (!isValid) return;
    
          window._learnq.push(['identify', {
            '$email': email.value
          }]);
          setTimeout((e) => {
            console.info('resend the quiz result!');
            window._learnq.push(['track', 'Send Quiz']);
          }, 1000);
    
          document.querySelector('.email-wrapper').remove();
          let successMsg = document.createElement('p');
          successMsg.classList.add('success-message');
          successMsg.textContent = 'your results have been sent to your inbox.';
    
          resultLink.parentElement.parentElement.after(successMsg);
    
          gtag("event", "click", {
            "event_category": "quiz",
            "event_label": 'resend quiz'
          });
    
        });
      }
    });

  }

  document.querySelectorAll('.main .shopify-section:first-of-type, .quiz-step, .quiz-result').forEach((step) => {
    step.style.display = 'none';
  });

  [...document.querySelectorAll('.shopify-section')].slice(-6, -1).forEach((result) => {
    result.style.display = 'none';
  });

  [...document.querySelectorAll('.featured-collection-grid__product')].forEach((product) => {
    product.style.display = "block";
  });
}

// on page load all sections are hidden except for the hero
// -- Exception #1: session already contain result
if ((window.location.hash === '#see-my-results' && getCookie('post') !== '') || window.location.search.indexOf('post') !== -1) {
  // record result to cookie when coming from param
  if (window.location.search.indexOf('post') !== -1) {
    setCookie('post', decodeURIComponent(getParam('post').replace(/%20/g, '+')), 30);
  }

  goToResults();
  updateNav();
} else {
  initiateFirstStep();
}

var sendToKlaviyo = (stak) => {
  // track email and quiz result to Klaviyo
  window._learnq.push(['identify', {
    '$email': document.getElementById('email').value
  }]);
  
  var klaviyoPushData = {
    'Source': 'Quiz',
    'Stak': btoa(JSON.stringify(stak)),
    'Concealer': stak.concealer,
    'BBPowder': stak.bb_powder,
    "BronzingBalm": stak.bronzing_balm,
    'Bronzer': stak.bronzer,
    'Highlighter': stak.highlighter,
    'LipCheek': stak.lipcheek,
    'ShineControl': stak.shine_control,
    'EyeShadow': stak.eyeshadow,
    'Blush': stak.blush,
    'Brow': stak.browColor,
    'LipGlaze':stak.lip_glaze,
    'Findation':stak.findation_recommendation
  }

  document.querySelectorAll('input[required]:checked').forEach((input) => {
    let heading = input.parentElement.parentElement.querySelector('.rich-text__heading').textContent;

    if (heading.indexOf('skin tone') !== -1) {
      klaviyoPushData['Skin Tone'] = input.value.toLowerCase();
    } else if (heading.indexOf('eye color') !== -1) {
      klaviyoPushData['Eye Color'] = input.value.toLowerCase();
    } else if(heading.indexOf('makeup') !== -1) {
      klaviyoPushData['Makeup Style'] = input.value.toLowerCase();
    } else if(heading.indexOf('describe your skin') !== -1) {
      klaviyoPushData['Skin Type'] =  input.value.toLowerCase();
    } else if(heading.indexOf('brow hair color') !== -1) {
      klaviyoPushData['Brow Hair Color'] = input.value.toLowerCase();
    }
  });

  document.querySelectorAll('.rich-text__heading').forEach((heading) => {
    let title = heading.innerText.toLowerCase();
    let inputIsChecked = heading.parentElement.querySelector('input:checked') !== null;

    if (title.indexOf('age') !== -1 && inputIsChecked) {
      klaviyoPushData['Age Range'] = heading.parentElement.querySelector('input:checked').value.toLowerCase();
    } else if (title.indexOf('experience') !== -1 && inputIsChecked) {
      klaviyoPushData['Experience'] = heading.parentElement.querySelector('input:checked').value.toLowerCase();
    } else if (title.indexOf('price') !== -1 && inputIsChecked) {
      klaviyoPushData['Spend Range'] = heading.parentElement.querySelector('input:checked').value.toLowerCase();
    } else if (title.indexOf('how often do you wear') !== -1) {
      let radioGroup = heading.parentElement.querySelectorAll('.radio-group-block');
      radioGroup.forEach(group => {
        klaviyoPushData['Frequency: ' + group.getElementsByTagName('p')[0].innerHTML] = group.querySelector('input:checked') ? group.querySelector('input:checked').value.toLowerCase() : 'Not selected';
      });
    } else if (title.indexOf('shades of eyeshadow') !== -1 && inputIsChecked) {
      klaviyoPushData['Eyeshadow Shade Preference'] = heading.parentElement.querySelector('input:checked').parentElement.querySelector('img').getAttribute('alt');
    } else if (title.indexOf('shades of lipstick') !== -1 && inputIsChecked) {
      klaviyoPushData['Lip Shade Preference'] = heading.parentElement.querySelector('input:checked').parentElement.querySelector('img').getAttribute('alt');
    } else if (title.indexOf('where do you typically shop') !== -1 && inputIsChecked) {
      klaviyoPushData['Retail Preference'] = heading.parentElement.querySelector('input:checked').value
        ? heading.parentElement.querySelector('input:checked').value.toLowerCase() : heading.parentElement.querySelector('input:checked').parentElement.querySelector('img').getAttribute('alt');
    }
  });

  let visibleProducts = [...document.querySelectorAll('.featured-collection-grid__product')].filter(p =>
    window.getComputedStyle(p).getPropertyValue('display') != 'none'
  );

  stak.add_all = '/cart/';
  stak.products = new Array();
  visibleProducts.forEach((p, i) => {
    let title = p.querySelector('.product-item__product-title').textContent.toLowerCase(), product = {}, rec;

    if (title.indexOf('concealer') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="' + stak.concealer + '"]');
    } else if (title.indexOf('bb powder') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="' + stak.bb_powder + '"]');
    } else if (title.indexOf('lip and cheek') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="' + stak.lipcheek + '"]');
    } else if (title.indexOf('eyeshadow') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="' + stak.eyeshadow + '"]');
    } else if (title.indexOf('blush') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="' + stak.blush + '"]');
    } else if (title.indexOf('bronzer') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="' + stak.bronzer + '"]');
    } else if (title.indexOf('bronzing balm') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="' + stak.bronzing_balm + '"]');
    } else if (title.indexOf('highlighter') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="' + stak.highlighter.replace('Cream', '').replace('Powder', '').trim() + '"]');
    }  else if (title.indexOf('shine control') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="' + stak.shine_control + '"]');
    } else if (title.indexOf('brow') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="' + stak.browColor + '"]');        
    } else if (title.indexOf('lip balm') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="Original Unflavored"]');
    } else if (title.indexOf('lip glaze') !== -1) {
      rec = p.querySelector('input[type="radio"][name="option-0"][value="' + stak.lip_glaze + '"]');
    }

    product.title = title.trim();
    product.image = rec.getAttribute('data-image-one');
    product.shade = rec.parentElement.getElementsByTagName('label')[0].innerText;
    stak.products.push(product);
    if(i > 0) {
      stak.add_all += ',';
    }
    stak.add_all += rec.getAttribute('data-variant-id') + ':1';
  });

  setTimeout(() => {
    window._learnq.push(['identify', klaviyoPushData]);
    window._learnq.push(['track', 'Submit Quiz', stak]);
  }, 1000);
}

var processResult = () => {
  /**
   * 
   * 1. Update message
   * 2. Create Stak
   * 3. Map Stak to products
   * 4. Store Stak in cookie
   * 5. Send Stak to Klaviyo
   * 6. Update nav status
   * 
   */

  // update message
  let resultDetail = document.querySelector('.featured-collection-grid__inner .featured-collection-grid__content .featured-collection-grid__subheading');
  if(resultDetail === null || document.querySelectorAll('.featured-collection-grid__inner .featured-collection-grid__content .featured-collection-grid__subheading').length === 1){
    resultDetail = document.querySelector('.quiz-result-detail .rich-text__heading + .rich-text__text');
  } else {
    if(document.querySelectorAll('.featured-collection-grid__inner .featured-collection-grid__content .featured-collection-grid__subheading').length > 1) {
      document.querySelector('.quiz-result-detail .rich-text__heading + .rich-text__text').innerHTML = "";
    }
  }
  let findationRec = document.getElementById('findation_result');
  let hasRec = false;

  if (findationRec.textContent === 'no recommendation') {
    // show submit selfie and skin tone message
    let skinToneInput = [...document.querySelectorAll('input[type="radio"].no-show-input:checked')].filter((input) => {
      let heading = input.parentElement.parentElement.querySelector('.rich-text__heading') ? input.parentElement.parentElement.querySelector('.rich-text__heading').textContent : '';
      return heading.indexOf('skin tone') !== -1;
    }).pop();

    let displayMsg = skinToneInput.getAttribute('data-msg');
    resultDetail.innerHTML = displayMsg;
  }

  if(document.querySelectorAll('.featured-collection-grid__inner .featured-collection-grid__content .featured-collection-grid__subheading').length === 1) {
    let ctas = [...document.querySelectorAll('.quiz-result-detail .rich-text__inner > *')].filter((el) => {
      return el.tagName === 'BUTTON' || el.tagName === 'A';
    });
    let hasScrollArrow = !!document.querySelector('.quiz-result-detail .scroll-down-arrow');

    if(ctas.length <= 0 && !hasScrollArrow) {
      const scrollArrow = document.createElement("div");
      scrollArrow.classList.add('scroll-down-arrow'); 

      document.querySelector('.quiz-result-detail .rich-text__inner').append(scrollArrow);
    }
  }

  let stak = createStak(hasRec, findationRec.textContent);
  mapToProducts(stak);

  let encodedStack = btoa(JSON.stringify(stak));
  setCookie('post', encodedStack, 30);

  sendToKlaviyo(stak);

  updateNav();
};

//go to results
document.querySelector('a[href="#see-my-results"]') && document.querySelector('a[href="#see-my-results"]').addEventListener('click', (evt) => {
  gtag("event", "click", {
    "event_category": "quiz",
    "event_label": "see my result"
  });
  goToResults();
});


document.querySelectorAll('a[href^="#quiz-step"]').forEach((qs) => {
  qs.addEventListener('click', stepClickEvent);
});

document.querySelectorAll('input[type="radio"]').forEach((input) => {
  input.addEventListener('change', (evt) => {
    let target = evt.target;
    let questionContainer = target.parentElement.parentElement;

    //check if we got the required answer
    if (questionContainer.querySelectorAll('input[required]').length) {
      // remove any existing error message
      questionContainer.querySelectorAll('input[required]').forEach((e) => {
        e.classList.remove('error');
      });
      questionContainer.querySelector('.error-message') && questionContainer.querySelector('.error-message').remove();
    }
    
    target.parentElement.parentElement.querySelectorAll('input[type="radio"]').forEach((ir) => {
      ir.parentElement.classList.remove('selected');
    });

    if (target.checked) {
      target.parentElement.classList.add('selected');
    }
    
    let textarea = document.getElementById(target.getAttribute('id') + '-textarea');
    if (textarea) {
      if (target.value.toLowerCase().indexOf('specify') !== -1) {
        textarea.classList.remove('hidden');
      } else {
        textarea.classList.add('hidden');
      }
    }
  });
});

document.querySelector('a[href="#see-result"]').addEventListener('click', (evt) => {
  evt.preventDefault();

  let target = evt.target.getAttribute('href') ? evt.target : evt.target.parentElement;
  let questionContainer = target.parentElement.parentElement.parentElement;
  let email = questionContainer.querySelector('input[type="email"]');
  let isValid = validate(email, questionContainer);
  
  if (!isValid) return;

  // process Result
  processResult();

  // show result
  [...document.querySelectorAll('.quiz-step')].slice(last_step, last_step + 1).pop().style.display = "none";
  document.querySelector('.main .shopify-section:first-of-type').style.display = "none";
  document.querySelectorAll('.quiz-result').forEach((qr) => { qr.style.display = "block"; });
  [...document.querySelectorAll('.shopify-section')].slice(-6, -1).forEach((result) => {
    result.style.display = 'block';
  });

  gtag("event", "click", {
    "event_category": "quiz",
    "event_label": 'submit quiz'
  });
});

//reset
document.querySelector('a[href="#retake"]').addEventListener('click', (evt) => {
  evt.preventDefault();

  document.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
    input.checked = false;

    input.parentElement.classList.remove('selected');
  });

  // hide steps and results
  document.querySelectorAll('.main .shopify-section:first-of-type, .quiz-step, .quiz-result').forEach((step) => {
    step.style.display = 'none';
  });
  [...document.querySelectorAll('.shopify-section')].slice(-6, -1).forEach((result) => {
    result.style.display = 'none';
  });

  if([...document.querySelectorAll('.main .shopify-section')].slice(1, 2)[0].querySelector('a[href="#quiz-step2"]') == null) {
    initiateFirstStep();

    // show intro screen
    [...document.querySelectorAll('.main .shopify-section')].slice(1, 2).forEach((intro) => {
      intro.style.display = 'block';
    });
  } else {
    // show intro screen
    [...document.querySelectorAll('.main .shopify-section')].slice(1, 2).forEach((intro) => {
      intro.style.display = 'block';
    }); 
  }

  [...document.querySelectorAll('.featured-collection-grid__product')].forEach((product) => {
    product.style.display = "block";
  });

  history.pushState("", document.title, window.location.pathname + window.location.search);

  gtag("event", "click", {
    "event_category": "quiz",
    "event_label": 'retake quiz'
  });
});
